class itemImage extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            const index = this.getAttribute('data-index');
            const sendToGallery = new CustomEvent('open-lightbox', {
                detail: {
                    index: index
                }
            })

            document.querySelector('.lightboxGallery')?.dispatchEvent(sendToGallery)
        })
    }
}

customElements.define("cstm-item-image", itemImage);